export const SUIVI_FINANCIER = {
    SET_FILTER_SITE: 'SET_FILTER_SITE',
    SET_FILTER_DATE_FROM: 'SET_FILTER_DATE_FROM',
    SET_FILTER_DATE_TO: 'SET_FILTER_DATE_TO',
    SET_FILTER_TYPE_INTERVENTION_ID: 'SET_FILTER_TYPE_INTERVENTION_ID',

    SET_SCROLL: 'SET_SUIVI_FINANCIER_SCROLL_POSITION',
    SET_ITEMS_SUIVI_FINANCIER: 'SET_SUIVI_FINANCIER_ITEMS',
    ADD_ITEMS: 'ADD_ITEMS',
    RESET_ITEMS: 'RESET_ITEMS',

    SET_PAGE: 'SET_PAGE',
    SET_NB_PAGES: 'SET_NB_PAGES',
    SET_SCROLL_SUIVI_FINANCIER: 'SET_SUIVI_FINANCIER_SCROLL',

    SET_SORT_SUIVI_FINANCIER: 'SET_DEMANDE_SUIVI_FINANCIER_SORT',

    SET_IS_LOADING_SUIVI_FINANCIER: 'SET_SUIVI_FINANCIER_IS_LOADING',
    SET_ERROR_SUIVI_FINANCIER: 'SET_SUIVI_FINANCIER_ERROR',
    SET_XLS_IS_LOADING: 'SET_XLS_IS_LOADING',
    SET_PDF_IS_LOADING: 'SET_PDF_IS_LOADING'

};
